import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import TableHeader from "../../../../components/Tables/TableHeader";
import { Link } from "react-router-dom";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../../components/Tables/SimpleTableHeader";
import { Arr_SEFPages } from "../../../../../arrays/SEF/Arr_SEFPages";
import { Update_To_MongoDB_By_ID } from "../../../../api/Update_To_MongoDB_By_ID";
import { Post_Question_To_CurtAI_Medical_Overview } from "../../api/Post_Question_To_CurtAI_Medical_Overview";
import { Update_To_MongoDB_By_ID_No_Alert } from "../../../../api/Update_To_MongoDB_By_ID_No_Alert";

function TableOfViewRegisters({ Registers }) {
  const { logout } = StaffuseAuth();

  const [status, setStatus] = useState("");

  async function handleCreate(e, Register) {
    e.preventDefault();
    let allMedicalFields = Arr_SEFPages.filter(
      (Obj_SEFPage) => Obj_SEFPage.Medical === "Yes"
    );
    allMedicalFields = allMedicalFields.map((Obj_SEFPage) => {
      return Obj_SEFPage.MongoDB;
    });
    console.log("allMedicalFields");
    console.log(allMedicalFields);
    console.log("Register");
    console.log(Register);
    // Create a new object with the same properties as Register that are also in allMedicalFields
    let newMedicalFields = Object.keys(Register).reduce((acc, key) => {
      if (allMedicalFields.includes(key)) {
        acc[key] = Register[key];
      }
      return acc;
    }, {});
    console.log("newMedicalFields");
    console.log(newMedicalFields);
    //Extract all the Props and Values from the newMedicalFields nests object and create a string with the format "Prop: Value"
    let newMedicalFieldsString = Object.entries(newMedicalFields)
      .map(([key, value]) => {
        if (typeof value === "object") {
          return `${Object.entries(value)
            .filter(([key2, value2]) => value2 !== "No")
            .map(([key2, value2]) => `${key2}: ${value2}`)
            .join(", ")}`;
        } else {
          return `${key}: ${value}`;
        }
      })
      .join(", ");
    console.log("newMedicalFieldsString");
    console.log(newMedicalFieldsString);
    console.log("Start");
    let answer = await Post_Question_To_CurtAI_Medical_Overview(
      newMedicalFieldsString,
      logout
    );
    console.log("answer");
    console.log(typeof answer);
    console.log(answer);
    console.log(answer[0]);

    Update_To_MongoDB_By_ID_No_Alert(
      { "SEFInfo.MedicalOverview": answer[0] },
      "Registers_2025",
      "All",
      Register._id,
      logout
    );
  }

  function sendAll(e) {
    e.preventDefault();
    Registers.forEach((Register) => {
      handleCreate(e, Register);
    });
  }

  //-----------------------------Return---------------------------------------------

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        View Register
      </Typography>
      <button onClick={(e) => sendAll(e)}>Update All</button>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              <>{SimpleTableHeader("_id")}</>
              <>{SimpleTableHeader("Created At")}</>
              <>{SimpleTableHeader("Name")}</>
              <>{SimpleTableHeader("ProgrammeTitle")}</>
              <>{SimpleTableHeader("ProgrammeDate")}</>
              <>{SimpleTableHeader("ProgrammeVarient")}</>
              <>{SimpleTableHeader("View")}</>
              <>{SimpleTableHeader("SEF")}</>
              <>{SimpleTableHeader("Create/Log/Save")}</>
            </TableRow>
          </TableHead>
          <TableBody>
            {Registers.map((Register, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor:
                    Register?.MetaData?.Archived === "Yes"
                      ? "rgba(139, 0, 0, 0.5)"
                      : Register?.MetaData?.Reserved === "Yes"
                      ? "rgba(0, 0, 139, 0.5)"
                      : Register?.MetaData?.Bursary === "Yes"
                      ? "rgba(144, 238, 144, 0.5)"
                      : "",
                  "&:hover": {
                    backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word", // Adjust padding here to make cells smaller
                    },
                  },
                }}
              >
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register._id}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.Created_At
                      ? Register.BasicInfo.Created_At
                      : ""}
                  </TableCell>
                </>

                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.First_Name
                      ? Register.BasicInfo.First_Name
                      : ""}{" "}
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.Last_Name
                      ? Register.BasicInfo.Last_Name
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeTitle
                      ? Register.BasicInfo.ProgrammeTitle
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeDate
                      ? Register.BasicInfo.ProgrammeDate
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register &&
                    Register.BasicInfo &&
                    Register.BasicInfo.ProgrammeVarient
                      ? Register.BasicInfo.ProgrammeVarient
                      : ""}
                  </TableCell>
                </>
                {/* New TableCell for update action using Link */}
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Link
                    to={`/Staff/ViewAttendee/${Register._id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button>View</button>
                  </Link>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {Register.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
                    "summer"
                  ) ? (
                    <>
                      <Link
                        to={`/Staff/ViewSEFReview/${Register._id}`}
                        target="_blank"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <button>
                          SEF{" "}
                          {Register.SEFInfo?.SEF
                            ? Register.SEFInfo?.SEF.replaceAll("_", " ")
                            : "Not Started"}
                        </button>
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {Register.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
                    "summer"
                  ) ? (
                    <>
                      <button onClick={(e) => handleCreate(e, Register)}>
                        Create
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                </TableCell>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Register.SEFInfo?.MedicalOverview || ""}
                  </TableCell>
                </>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TableOfViewRegisters;
